import { IsBoolean, IsEmail, IsOptional, IsString, MinLength } from 'class-validator';

import { IsMatch, IsNotBlank } from '@/helper';
import { OptionSelect } from '@/types';

export class CreateTenantFormSchema {
    @IsString()
    @IsNotBlank({ message: 'Workspace name is required' })
    name!: string;
}

export class LoginFormSchema {
    @IsString()
    @IsEmail({}, { message: 'Email is not valid' })
    @IsNotBlank({ message: 'Email is required' })
    email!: string;

    @IsString()
    @IsNotBlank({ message: 'Password is required' })
    @MinLength(8, { message: 'Password must be at least 8 characters.' })
    password!: string;

    rememberMe!: boolean;
}

export class SignupFormSchema {
    @IsString()
    @IsNotBlank({ message: 'Name is required' })
    name!: string;

    @IsString()
    @IsEmail({}, { message: 'Email is not valid' })
    @IsNotBlank({ message: 'Email is required' })
    email!: string;

    @IsString()
    @IsNotBlank({ message: 'Password is required' })
    @MinLength(8, { message: 'Password must be at least 8 characters.' })
    password!: string;
}

export class ForgotPasswordFormSchema {
    @IsEmail({}, { message: 'Email is not valid' })
    @IsNotBlank({ message: 'Email is required' })
    email!: string;
}

export class ResetPasswordFormSchema {
    @IsString()
    @IsNotBlank({ message: 'Password is required' })
    @MinLength(8, { message: 'Password must be at least 8 characters.' })
    password!: string;

    @IsString()
    @IsNotBlank({ message: 'Password is required' })
    @MinLength(8, { message: 'Password must be at least 8 characters.' })
    @IsMatch('password', {
        message: 'The passwords must match'
    })
    confirmPassword!: string;
}

export class InviteMemberFormSchema extends ForgotPasswordFormSchema {
    role!: OptionSelect;
}
